module.exports = __webpack_public_path__ + "static/sport/login-2.15c0cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/form/login-2.png
// module id = JBiA
// module chunks = 0